const VanDerWaalsRadii = Object.freeze({
    H: 120,
    He: 140,
    Li: 182,
    Be: 153,
    B: 192,
    C: 170,
    N: 155,
    O: 152,
    F: 147,
    Ne: 154,
    Na: 227,
    Mg: 173,
    Al: 184,
    Si: 210,
    Pi: 180,
    S: 180,
    Cl: 175,
    Ar: 188,
    K: 275,
    Ca: 231,
    Ni: 163,
    Cu: 140,
    Zn: 139,
    Ga: 187,
    Ge: 211,
    As: 185,
    Se: 190,
    Br: 185,
    Kr: 202,
    Rb: 303,
    Sr: 249,
    Pd: 163,
    Ag: 172,
    Cd: 158,
    In: 193,
    Sn: 217,
    Sb: 206,
    Te: 206,
    I: 198,
    Xe: 216,
    Cs: 343,
    Ba: 268,
    Pt: 175,
    Au: 166,
    Hg: 155,
    Tl: 196,
    Pb: 202,
    Bi: 207,
    Po: 197,
    At: 202,
    Rn: 220,
    Fr: 348,
    Ra: 283,
    default: 200
});

const CovalentRadii = {
    H: 25,
    Li: 145,
    Be: 105,
    B: 85,
    C: 70,
    N: 65,
    O: 60,
    F: 50,
    Na: 180,
    Mg: 150,
    Al: 125,
    Si: 110,
    P: 100,
    S: 100,
    Cl: 100,
    K: 220,
    Ca: 180,
    Sc: 160,
    Ti: 140,
    V: 135,
    Cr: 140,
    Mn: 140,
    Fe: 140,
    Co: 135,
    Ni: 135,
    Cu: 135,
    Zn: 135,
    Ga: 130,
    Ge: 125,
    As: 115,
    Se: 115,
    Br: 115,
    Rb: 235,
    Sr: 200,
    Y: 180,
    Zr: 155,
    Nb: 145,
    Mo: 145,
    Tc: 135,
    Ru: 130,
    Rh: 135,
    Pd: 140,
    Ag: 160,
    Cd: 155,
    In: 155,
    Sn: 145,
    Sb: 145,
    Te: 140,
    I: 140,
    Cs: 260,
    Ba: 215,
    La: 195,
    Ce: 185,
    Pr: 185,
    Nd: 185,
    Pm: 185,
    Sm: 185,
    Eu: 185,
    Gd: 180,
    Tb: 175,
    Dy: 175,
    Ho: 175,
    Er: 175,
    Tm: 175,
    Yb: 175,
    Lu: 175,
    Hf: 155,
    Ta: 145,
    W: 135,
    Re: 135,
    Os: 130,
    Ir: 135,
    Pt: 135,
    Au: 135,
    Hg: 150,
    Tl: 190,
    Pb: 180,
    Bi: 160,
    Po: 190,
    Ra: 215,
    Ac: 195,
    Th: 180,
    Pa: 180,
    U: 175,
    Np: 175,
    Pu: 175,
    Am: 175,
    default: 100
};

const ColorScheme = (function () {
    function createColors(atom, brand, text) { return Object.freeze({ atom, brand, text }); }

    function createScheme(_default, ...atoms) {
        return Object.freeze(atoms.reduce((scheme, value) => {

            const [color, ...atoms] = value;

            atoms.forEach(atom => scheme[atom] = color);

            return scheme;
        }, {
            default: _default
        }));
    }

    return Object.freeze({
        ChimeraCPK: Object.freeze(
            createScheme(
                createColors(0xff1493, 0xfe2b94, 0x000000),
                // [createColors(0xc8c8c8, 0x000000, 0xffffff), "C"],
                [createColors(0x000000, 0x000000, 0xffffff), "C"],
                [createColors(0xffffff, 0xfcfcfe, 0x000000), "H"],
                [createColors(0xf00000, 0xf00000, 0xffffff), "O"],
                // [createColors(0x8f8fff, 0x9999ff, 0x000000), "N"],
                [createColors(0x8080ff, 0x9999ff, 0x000000), "N"],
                [createColors(0xffc832, 0xffcb3f, 0x000000), "S"],
                [createColors(0xffa500, 0xffb200, 0x000000), "P", "Fe", "Ba"],
                [createColors(0x0000ff, 0x0000ff, 0xffffff), "K", "Na"],
                [createColors(0x228b22, 0x2ea434, 0xffffff), "Mg"],
                [createColors(0x808090, 0x858096, 0xffffff), "Ca", "Mn", "Cr", "Al", "Ti", "Ag"],
                [createColors(0xa52a2a, 0x932100, 0xffffff), "Zn", "Cu", "Ni", "Br"],
                [createColors(0x00ff00, 0x00ff00, 0x000000), "Cl", "B"],
                [createColors(0xdaa520, 0xdb9200, 0x000000), "F", "Si", "Au"],
                [createColors(0xa020f0, 0xa020f0, 0x000000), "I"],
                [createColors(0xb22222, 0x7a1400, 0xffffff), "Li"],
                [createColors(0xffc0cb, 0xfdabb9, 0x000000), "He"],
            )
        )
    });
})();

export { VanDerWaalsRadii, ColorScheme, CovalentRadii };